const icons = {
  spark:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2l1.7 6.1 6.1 1.7-6.1 1.7L12 17.8l-1.7-6.1L4.2 10l6.1-1.7z" fill="currentColor"/></svg>',
  db:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><ellipse cx="12" cy="5.5" rx="7" ry="2.8"/><path d="M5 5.5v13c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8v-13"/><path d="M5 12c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8"/></svg>',
  cloud:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M7.5 18.5a4.2 4.2 0 0 1-.3-8.4 5.2 5.2 0 0 1 10-1.1 3.7 3.7 0 0 1-.2 9.5z"/></svg>',
  lock:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4.5" y="10.5" width="15" height="9.5" rx="2.2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
  chart:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><rect x="3.8" y="12" width="3.4" height="8" rx="1"/><rect x="10.3" y="6.5" width="3.4" height="13.5" rx="1"/><rect x="16.8" y="9.5" width="3.4" height="10.5" rx="1"/></svg>',
  api:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4.5C6.4 4.5 7.4 11 4.5 11.5c2.9.5 1.9 8 4.5 8"/><path d="M15 4.5c2.6 0 1.6 6.5 4.5 7-2.9.5-1.9 8-4.5 8"/></svg>',
  doc:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M7 3.2h6.5L18 7.7V20.8H7z"/><path d="M13.3 3.4v4.4h4.4"/></svg>',
  grid:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4" y="4" width="7" height="7" rx="1.4"/><rect x="13" y="4" width="7" height="7" rx="1.4"/><rect x="4" y="13" width="7" height="7" rx="1.4"/><rect x="13" y="13" width="7" height="7" rx="1.4"/></svg>',
  react:
    '<svg viewBox="-12 -12 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.1"><circle r="2.1" fill="currentColor" stroke="none"/><ellipse rx="10" ry="4"/><ellipse rx="10" ry="4" transform="rotate(60)"/><ellipse rx="10" ry="4" transform="rotate(120)"/></svg>',
  node:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M12 2.2 21 7.1v9.8L12 21.8 3 16.9V7.1Z"/></svg>',
  ts:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="1.5" y="1.5" width="21" height="21" rx="4" fill="currentColor"/><text x="12" y="16.5" text-anchor="middle" font-family="monospace" font-weight="700" font-size="11" fill="var(--panel)">TS</text></svg>',
  next:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><text x="12" y="17" text-anchor="middle" font-family="monospace" font-weight="700" font-size="13" fill="var(--panel)">N</text></svg>',
  braces:
    '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 4.5C6.5 4.5 7 9 7 11c0 .8-1 1-2 1 1 0 2 .2 2 1 0 2-.5 6.5 1.5 6.5"/><path d="M15.5 4.5c2 0 1.5 4.5 1.5 6.5 0 .8 1 1 2 1-1 0-2 .2-2 1 0 2 .5 6.5-1.5 6.5"/></svg>',
}

function pickIcon(label: string) {
  const value = label.toLowerCase()
  if (/\bai\b|openai|\bllm\b|gpt|analysis|\bsearch\b/.test(value)) return icons.spark
  if (/auth|secure|security|\brls\b|login|session/.test(value)) return icons.lock
  if (/cloudflare|workers|\bcloud\b|vercel|edge/.test(value)) return icons.cloud
  if (/postgres|neon|pgvector|\bsql\b|\bd1\b|\br2\b|storage|drizzle|\borm\b|database|prisma|redis/.test(value)) return icons.db
  if (/posthog|analytic|\bstats\b|metric|telemetry/.test(value)) return icons.chart
  if (/\bpdf\b|puppeteer|export|\bdoc/.test(value)) return icons.doc
  if (/\bapi\b|propertyfinder|integration|webhook|stripe|payment/.test(value)) return icons.api
  if (/admin|dashboard|\bcms\b|panel/.test(value)) return icons.grid
  if (/typescript|\bts\b/.test(value)) return icons.ts
  if (/next\.?js|nextjs/.test(value)) return icons.next
  if (/\breact\b/.test(value)) return icons.react
  if (/\bnode/.test(value)) return icons.node
  return icons.braces
}

export function injectChipIcons(root: ParentNode = document) {
  root.querySelectorAll<HTMLElement>('.chip').forEach((chip) => {
    if (chip.querySelector('svg') || chip.dataset.noicon !== undefined) return

    const label = chip.textContent?.trim()
    if (!label) return

    chip.insertAdjacentHTML('afterbegin', pickIcon(label))
  })
}
